<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zoEXB0/tc-custom/9781467448499.jpg?1708516472269" alt="This image is the cover for the book Stay in the City"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stay in the City
      </h1>
      <p class="bookDescription body article font2">
        <p>We live in an urban age. To a degree unprecedented in human history, most of the world's people live in cities. It is thus vital, say Mark Gornik and Maria Liu Wong, for Christians to think constructively about how to live out their faith in an urban setting.<br/><br/> In <i>Stay in the City</i> Gornik and Liu Wong look at what is happening in the urban church—and what Christians everywhere can learn from it. Once viewed suspiciously for their worldly temptations and vices, cities are increasingly becoming centers of vibrant Christian faith. Writing from their experience living and working in New York City, Gornik and Liu Wong invite readers everywhere to join together in creating a more flourishing—and faith-filled—urban world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark R. Gornik, Maria Liu Wong, Timothy Keller, Peter and Miriam Yvette Acevedo
      </h2>
      
      <p class="authorDescription body article">Mark R. Gornik is director of City Seminary of New York. He served previously as the founding pastor of New Song Community Church in Baltimore and is also the author of <em>To Live in Peace: Biblical Faith and the Changing Inner City</em>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e0e8257e